const state = {
    stacksBarClass: [
        "stacked-bar-time",
        "stacked-bar-time-24",
        "stacked-bar-time-12",
        "stacked-bar-time-24",
        "stacked-bar-time-6",
        "stacked-bar-time-24",
        "stacked-bar-time-12 stacked-bar-time-6",
        "stacked-bar-time-24",
        "stacked-bar-time-6",
        "stacked-bar-time-24",
        "stacked-bar-time-12",
        "stacked-bar-time-24",
        "stacked-bar-time-3",
        "stacked-bar-time-24",
        "stacked-bar-time-12",
        "stacked-bar-time-24",
        "stacked-bar-time-6",
        "stacked-bar-time-24",
        "stacked-bar-time-12 stacked-bar-time-6",
        "stacked-bar-time-24",
        "stacked-bar-time-6",
        "stacked-bar-time-24",
        "stacked-bar-time-12",
        "stacked-bar-time-24",
        "stacked-bar-time",
    ],
    stacksBarMaxValue: 86400,
    stacksData: {},
}
const getters = {
    get_stacksBarClass: state => {
        return state.stacksBarClass
    },
    get_stacksBarMaxValue: state => {
        return state.stacksBarMaxValue
    },
    get_stacksData: state => {
        return state.stacksData
    },
}
const actions = {
    set_stacksBarClass(context, array) {
        context.commit('SET_STACKSBARCLASS', array);
    },
    set_stacksBarMaxValue(context, number) {
        context.commit('SET_STACKSBARMAXVALUE', number);
    },
    set_stacksData(context, obj) {
        context.commit('SET_STACKSDATA', obj);
    },
    clear_stacksData(context) {
        context.commit('CLEAR_STACKSDATA');
    }
}
const mutations = {
    SET_STACKSBARCLASS(state, array) {
        state.stacksBarClass = array;
    },
    SET_STACKSBARMAXVALUE(state, number) {
        state.stacksBarMaxValue = number;
    },
    SET_STACKSDATA(state, obj) {
        let obj_key = Object.keys(obj);
        let stacksStartTime = 0;

        for (let i = 0; i < obj_key.length; i++) {
            if (obj[obj_key[i]][0]['startTime'] == undefined) {
                break;
            }
            stacksStartTime = obj[obj_key[i]][0]['startTime'].split(' ')[1].split(":")[0];
            let stacksBarNumber = [];
            for (let i = 0; i < 25; i++) {
                let this_value = Number(stacksStartTime) + i;
                if (this_value >= 24) {
                    this_value -= 24;
                }
                stacksBarNumber.push(padLeft(this_value, 2));
            }
            obj[obj_key[i]][0]['stacksStartTime'] = stacksStartTime
            obj[obj_key[i]][0]['stacksBarNumber'] = stacksBarNumber
        }
        //新增時間
        state.stacksData = obj;
    },
    CLEAR_STACKSDATA(state) {
        state.stacksData = { "-": [] };
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

function padLeft(str, lenght) {
    if ((str + "").length >= lenght) return str + "";
    else return padLeft("0" + str, lenght);
}


// WEBPACK FOOTER //
// ./src/store/modules/stackBar.js